import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';


export default class PollBanStudentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            disabledButton: false

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.click = this.click.bind(this);
    }
    // imam pristup id ankete proslijedjen preko location(link)
    componentDidMount() {
        this.getStudents();
    }
    getStudents() {
        let { pollId } = JSON.parse(localStorage.getItem('poll'));
        let courseId = localStorage.getItem('courseId');
        axios.get(`/questionnaire/access-status/${courseId}/${pollId}/`)
            .then(res => {
                const students = res.data;
                this.setState({
                    data: students, loader: false, loading: false, disabledButton: false
                });
            })
            .catch(err => {
                this.setState({ loading: false });
                console.log('Failed to fetch courses.');
            });
    }

    click(el, id) {
        let courseId = localStorage.getItem('courseId');
        let { pollId } = JSON.parse(localStorage.getItem('poll'));
        this.setState({ loader: true, id });
        let obj = {
            courseImplementation: { id: courseId },
            id: el.studentCourseImplementationId
        };
        let forbidId = el.accessStatus ? 1 : 0;
        axios.post(`/questionnaire/change-access-status/${pollId}/${forbidId}/`, obj)
            .then((res) => {
                this.getStudents();
            }).catch(() => {
                this.setState({ loader: false });
                toast('Došlo je do greške, nije moguće promijeniti pristup studentu.');
            });
    }
    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        return (
            <div>
                <Header as="h2"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> <FormattedMessage id="common.studentsList" /> </Header></Segment>
                    <Segment>
                        {this.state.loading ? <Loader active inline="centered" /> :
                            this.getDataToRender().length ? <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row >
                                        <Table.HeaderCell >
                                            <FormattedMessage id="common.firstName" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell >
                                            <FormattedMessage id="common.lastName" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell >
                                            <FormattedMessage id="poll.sp" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell >
                                            <FormattedMessage id="common.index" />
                                        </Table.HeaderCell>

                                        <Table.HeaderCell >
                                            <FormattedMessage id="poll.access" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell >

                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {this.getDataToRender().map((el, index) =>
                                        (<Table.Row
                                            key={el.id}
                                            positive={el.accessStatus}
                                            negative={!el.accessStatus}
                                        >
                                            <Table.Cell verticalAlign="middle">
                                                {el.firstName ? el.firstName : '/'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.lastName ? el.lastName : '/'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {el.studyProgramBasicName ? el.studyProgramBasicName : '/'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                {el.index ? el.index : '/'}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" >
                                                <Icon name={el.accessStatus ? 'checkmark' : 'close'} />
                                                {el.accessStatus.toString() === 'true' ? <FormattedMessage id="poll.accessGranted" /> : <FormattedMessage id="poll.accessProhibited" />}

                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" textAlign="center" >
                                                <Button
                                                    basic
                                                    loading={this.state.loader && el.studentCourseImplementationId === this.state.id}
                                                    color="blue"
                                                    disabled={this.state.disabledButton}
                                                    onClick={
                                                        () => {
                                                            this.setState({ disabledButton: true }, () => {
                                                                this.click(el, el.studentCourseImplementationId);
                                                            });
                                                        }
                                                    }
                                                > {el.accessStatus ? <FormattedMessage id="poll.ban" /> : <FormattedMessage id="poll.approve" /> }

                                                </Button>
                                            </Table.Cell>

                                        </Table.Row>))}
                                </Table.Body>

                            </Table> : <FormattedMessage id="poll.noStudentsMess" />
                        } </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>

            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/PollBan/PollBanStudentList.js